import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import LearnMore from './LearnMore';

class Page extends Component {

  static propTypes = {
    footer: PropTypes.bool,
    children: PropTypes.element,
    className: PropTypes.string,
    location: PropTypes.object.isRequired
  };

  static defaultProps = {
    footer: true
  };

  render() {
    const { footer, location, className } = this.props;

    return (
      <div className={`page flex-element flex-container flex-vertical ${className}`}>
        <header className='page-header'>
          <NavBar />
        </header>

        <section className='page-body flex-container flex-element position-relative'>
          <LearnMore location={location} />
          { this.props.children }
        </section>

        { footer &&
          <footer className='page-footer'>
            <Footer />
          </footer> }
      </div>
    );
  }

}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js